import { createContext } from 'react';
import { i as initialUIDPrefixer } from './initialUIDPrefixer-Bc3M2jF8.js';

const UIDContext = /*#__PURE__*/createContext(initialUIDPrefixer);

export { UIDContext as U };
//# sourceMappingURL=UIDContext-DaboSTJ1.js.map
